module.exports = __webpack_public_path__ + "static/media/orange-solid-checked.f42456fd.svg";